export default (userData: object): void => localStorage.setItem('userData', JSON.stringify(userData))
